import type { Middleware } from '@reduxjs/toolkit'

export const customMiddleware: Middleware[] = []
